import React, { useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import RestaurantList from '../RestaurantList/RestaurantList';
import ProductGroupsTab from '../ProductGroupsTab/ProductGroupsTab';
import EquipmentTab from '../EquipmentTab/EquipmentTab';
import CommoditiesTab from '../CommoditiesTab/CommoditiesTab';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import AttributesTab from '../AttributesTab/AttributesTab';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Tooltip from '@material-ui/core/Tooltip';
import { getHealthCheckMDS } from '../../redux/actions/newOperationHoursActions';
import OperationHoursMassUpdateMaster from '../OperationHoursMassUpdateMaster';
import OperationHoursTab from '../OperationHoursTab/OperationHoursTabOld';
import OperationRestaurantCard from '../OperationHoursTab/RestaurantDetails/OperationRestaurantCardOld';
import { shouldEnableNewWeekView } from '../../utils/newWeekViewFeatureFlags';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <section>{children}</section>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  tabs: {
    fontSize: 12,
    color: theme.palette.constrastGreyBlack.main,
    textTransform: 'none',
  },
  subMenusColor: {
    backgroundColor: theme.palette.appBarsColor.main,
  },
}));

const options = {
  restaurants: 0,
  equipments: 1,
  operations: 2,
  products: 3,
  commodities: 4,
  attributes: 5,
};
const optionsReverse = {
  '0': 'restaurants',
  '1': 'equipments',
  '2': 'operations',
  '3': 'products',
  '4': 'commodities',
  '5': 'attributes',
};
type TABProps = {
  option: string;
  restaurantId?: string;
};

export default function FullWidthTabs() {
  const { option } = useParams<TABProps>();
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const history = useHistory();
  const dispatch: any = useDispatch();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const location = useLocation();
  const handleChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number,
  ) => {
    console.log(newValue);
    setValue(newValue);
    history.push(`/${optionsReverse[newValue]}`);
  };

  useEffect(() => {
    if (
      (!thisUser.hasViewCommodities && location.pathname === '/commodities') ||
      (!thisUser.hasViewMenuItemOperationHours &&
        location.pathname === '/operations')
    ) {
      history.push('/');
    }

    if (location.pathname === '/restaurants') {
      setValue(0);
    }
  }, [
    history,
    location.pathname,
    thisUser.hasViewCommodities,
    thisUser.hasViewMenuItemOperationHours,
  ]);

  const { t } = useTranslation();

  const handleChangeIndex = (index: number) => {
    setValue(index);
    history.push(`/${optionsReverse[index]}`);
  };
  useEffect(() => {
    if (typeof option !== 'undefined') {
      setValue(options[option]);
      dispatch({ type: 'UI_OPEN_TXTFLD', payload: false });
    }
  }, [option]);
  const { enableDynamicAttribute, ramWarningBarToggle, newWeekViewFlags } =
    useFlags();
  const state = useSelector((state: RootStateOrAny) => state);
  const isNewWeekViewEnabled = shouldEnableNewWeekView(state, newWeekViewFlags);
  useEffect(() => {
    dispatch(getHealthCheckMDS());
  }, []);

  const { isMDSUpAndRunning } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );

  function shouldDisableOperationHoursTab() {
    return !isMDSUpAndRunning;
  }

  function getSystemDownTooltipMessage() {
    if (ramWarningBarToggle && !isMDSUpAndRunning)
      return t('operationHours.plannedMaintenance');
    if (!isMDSUpAndRunning) return t('operationHours.unplannedMaintenance');
    return '';
  }

  const tabsDesktop = (
    <Tabs
      value={value}
      onChange={handleChange}
      className={classes.subMenusColor}
      indicatorColor="secondary"
      textColor="inherit"
      variant="fullWidth"
      aria-label="full width tabs example"
    >
      <Tab
        className={classes.tabs}
        label={t('app.nav.main.restaurantList')}
        value={0}
        {...a11yProps(0)}
      />
      <Tab
        className={classes.tabs}
        label={t('app.nav.main.equipmentManagement')}
        value={1}
        {...a11yProps(1)}
      />
      {thisUser.hasViewMenuItemOperationHours && (
        <Tab
          style={{ pointerEvents: 'auto' }}
          className={classes.tabs}
          label={
            <Tooltip title={getSystemDownTooltipMessage()}>
              <span>{t('app.nav.main.operationHours')}</span>
            </Tooltip>
          }
          value={2}
          {...a11yProps(2)}
          disabled={shouldDisableOperationHoursTab()}
        />
      )}
      {(thisUser.hasViewMenuItemList ||
        thisUser.hasViewMenuItemListAndDetails) && (
        <Tab
          className={classes.tabs}
          label={t('app.nav.main.productGroups')}
          value={3}
          {...a11yProps(3)}
        />
      )}
      {thisUser.hasViewCommodities && (
        <Tab
          className={classes.tabs}
          label={t('app.nav.main.commoditiesManagement')}
          value={4}
          {...a11yProps(4)}
        />
      )}
      {enableDynamicAttribute && (
        <Tab
          className={classes.tabs}
          label={t('app.nav.main.attributes')}
          value={5}
          {...a11yProps(5)}
        />
      )}
    </Tabs>
  );
  const tabsTablets = (
    <Tabs
      value={value}
      onChange={handleChange}
      className={classes.subMenusColor}
      indicatorColor="secondary"
      textColor="inherit"
      variant="scrollable"
      scrollButtons="auto"
      aria-label="full width tabs example"
    >
      <Tab
        className={classes.tabs}
        label={t('app.nav.main.restaurantList')}
        value={0}
        {...a11yProps(0)}
      />
      <Tab
        className={classes.tabs}
        label={t('app.nav.main.equipmentManagement')}
        value={1}
        {...a11yProps(1)}
      />
      {thisUser.hasViewMenuItemOperationHours && (
        <Tab
          style={{ pointerEvents: 'auto' }}
          className={classes.tabs}
          label={
            <Tooltip title={getSystemDownTooltipMessage()}>
              <span>{t('app.nav.main.operationHours')}</span>
            </Tooltip>
          }
          value={2}
          {...a11yProps(2)}
          disabled={shouldDisableOperationHoursTab()}
        />
      )}
      {(thisUser.hasViewMenuItemList ||
        thisUser.hasViewMenuItemListAndDetails) && (
        <Tab
          className={classes.tabs}
          label={t('app.nav.main.productGroups')}
          value={3}
          {...a11yProps(3)}
        />
      )}
      {thisUser.hasViewCommodities && (
        <Tab
          className={classes.tabs}
          label={t('app.nav.main.commoditiesManagement')}
          value={4}
          {...a11yProps(4)}
        />
      )}
      {/* dynamic attributes TODO permission */}
      {enableDynamicAttribute && (
        <Tab
          className={classes.tabs}
          label="Attributes"
          value={5}
          {...a11yProps(5)}
        />
      )}
    </Tabs>
  );
  return (
    <div className={classes.root}>
      <AppBar position="static" color="primary">
        {matches ? tabsTablets : tabsDesktop}
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <RestaurantList />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <EquipmentTab />
        </TabPanel>
        {thisUser.hasViewMenuItemOperationHours && (
          <TabPanel value={value} index={2} dir={theme.direction}>
            {isNewWeekViewEnabled ? (
              <OperationHoursMassUpdateMaster />
            ) : (
              <>
                <OperationRestaurantCard />
                <OperationHoursTab />
              </>
            )}
          </TabPanel>
        )}
        <TabPanel value={value} index={3} dir={theme.direction}>
          <ProductGroupsTab />
        </TabPanel>
        {thisUser.hasViewCommodities && (
          <TabPanel value={value} index={4} dir={theme.direction}>
            <CommoditiesTab />
          </TabPanel>
        )}
        {/* dynamic attributes TODO permission */}
        {enableDynamicAttribute && (
          <TabPanel value={value} index={5} dir={theme.direction}>
            <AttributesTab />
          </TabPanel>
        )}
      </SwipeableViews>
    </div>
  );
}
